import { ROLES, getRoleImg, getRoleSVG } from "lib/role_helper.js";
import { getRegionUrl } from "@outplayed/riot-assets";

// ------------------------------------
// GENERAL OPTIONS
// ------------------------------------

export const ROLE_OPTIONS = [
  { value: ROLES.TOP, label: "Top", img: getRoleSVG(ROLES.TOP), imgActive: getRoleSVG(ROLES.TOP, { active: true }) },
  { value: ROLES.JUNGLE, label: "Jungle", img: getRoleSVG(ROLES.JUNGLE), imgActive: getRoleSVG(ROLES.JUNGLE, { active: true }) },
  { value: ROLES.MIDDLE, label: "Middle", img: getRoleSVG(ROLES.MIDDLE), imgActive: getRoleSVG(ROLES.MIDDLE, { active: true }) },
  { value: ROLES.BOTTOM, label: "Bot", img: getRoleSVG(ROLES.BOTTOM), imgActive: getRoleSVG(ROLES.BOTTOM, { active: true }) },
  {
    value: ROLES.SUPPORT,
    label: "Support",
    img: getRoleSVG(ROLES.SUPPORT),
    imgActive: getRoleSVG(ROLES.SUPPORT, { active: true }),
  },
];

export const ALL_ROLE_OPTIONS = [
  { value: ROLES.ALL, label: "All Roles", img: getRoleSVG(ROLES.ALL) },
  { value: ROLES.TOP, label: "Top", img: getRoleSVG(ROLES.TOP), imgActive: getRoleSVG(ROLES.TOP, { active: true }) },
  { value: ROLES.JUNGLE, label: "Jungle", img: getRoleSVG(ROLES.JUNGLE), imgActive: getRoleSVG(ROLES.JUNGLE, { active: true }) },
  { value: ROLES.MIDDLE, label: "Middle", img: getRoleSVG(ROLES.MIDDLE), imgActive: getRoleSVG(ROLES.MIDDLE, { active: true }) },
  { value: ROLES.BOTTOM, label: "Bot", img: getRoleSVG(ROLES.BOTTOM), imgActive: getRoleSVG(ROLES.BOTTOM, { active: true }) },
  {
    value: ROLES.SUPPORT,
    label: "Support",
    img: getRoleSVG(ROLES.SUPPORT),
    imgActive: getRoleSVG(ROLES.SUPPORT, { active: true }),
  },
];

export const QUEUE_TYPE_ID_OPTIONS = [
  { label: "All Ranked", value: "all_ranked" },
  { label: "Ranked Solo", value: "ranked_solo_5x5" },
  { label: "Ranked Flex", value: "ranked_flex_sr" },
  { label: "ARAM", value: "normal_aram" },
  { label: "Normal Blind", value: "normal_blind_5x5" },
  { label: "Normal Draft", value: "normal_draft_5x5" },
];

export const QUEUE_TYPE_RANKED = ["all_ranked", "ranked_solo_5x5", "ranked_flex_sr"];

export const QUEUE_TYPE_ID_MAP = {
  all_ranked: [420, 440],
  ranked_solo_5x5: [420],
  ranked_flex_sr: [440],
  normal_aram: [450],
  normal_blind_5x5: [430],
  normal_draft_5x5: [400],
  clash_5x5: [700],
};

export const QUEUE_TYPE_OPTIONS = [
  { value: "ranked_solo_5x5", label: "Ranked Solo" },
  { value: "normal_aram", label: "ARAM" },
  { value: "ranked_flex_sr", label: "Ranked Flex" },
  { value: "normal_blind_5x5", label: "Normal Blind" },
  { value: "normal_draft_5x5", label: "Normal Draft" },
  // { value: "clash_5x5", label: "Clash" },
  { value: "nexus_blitz", label: "Nexus Blitz" },
];

export const ALL_QUEUE_TYPE_OPTIONS = [
  { value: "all", label: "All Queue Types" },
  { value: "ranked_solo_5x5", label: "Ranked Solo" },
  { value: "normal_aram", label: "ARAM" },
  { value: "ranked_flex_sr", label: "Ranked Flex" },
  { value: "normal_blind_5x5", label: "Normal Blind" },
  { value: "normal_draft_5x5", label: "Normal Draft" },
  { value: "clash_5x5", label: "Clash" },
  { value: "nexus_blitz", label: "Nexus Blitz" },
];

export const REGION_OPTIONS = [
  { value: "world", label: "World", img: getRegionUrl("world") },
  { value: "na1", label: "NA", img: getRegionUrl("NA") },
  { value: "euw1", label: "EUW", img: getRegionUrl("EUW") },
  { value: "kr", label: "KR", img: getRegionUrl("flags/kr"), flag: true },
  { value: "br1", label: "BR", img: getRegionUrl("flags/br"), flag: true },
  { value: "eun1", label: "EUN", img: getRegionUrl("EUN") },
  { value: "jp1", label: "JP", img: getRegionUrl("flags/jp"), flag: true },
  { value: "la1", label: "LAN", img: getRegionUrl("LAN") },
  { value: "la2", label: "LAS", img: getRegionUrl("LAS") },
  { value: "oc1", label: "OCE", img: getRegionUrl("OCE") },
  { value: "ru", label: "RU", img: getRegionUrl("flags/ru"), flag: true },
  { value: "tr1", label: "TR", img: getRegionUrl("flags/tr"), flag: true },
  { value: "ph2", label: "PH", img: getRegionUrl("PH") },
  { value: "sg2", label: "SG", img: getRegionUrl("SG") },
  { value: "th2", label: "TH", img: getRegionUrl("TH") },
  { value: "tw2", label: "TW", img: getRegionUrl("TW") },
  { value: "vn2", label: "VN", img: getRegionUrl("VN") },
];

export const SEASON_OPTIONS = [
  { value: "21", label: "Season 13-2" },
  { value: "20", label: "Season 13-1" },
  { value: "19", label: "Preseason 13" },
  { value: "18", label: "Season 12" },
  { value: "17", label: "Preseason 12" },
  { value: "16", label: "Season 11" },
  { value: "15", label: "Preseason 11" },
];

export const CHAMPION_STATS_SEASON_OPTIONS = [
  { value: "21", label: "Season 13-2" },
  { value: "20", label: "Season 13-1" },
  { value: "18", label: "Season 12" },
  { value: "16", label: "Season 11" },
  { value: "14", label: "Season 10" },
  { value: "9", label: "Season 9" },
  { value: "8", label: "Season 8" },
  { value: "7", label: "Season 7" },
  { value: "6", label: "Season 6" },
  { value: "5", label: "Season 5" },
  { value: "4", label: "Season 4" },
  { value: "3", label: "Season 3" },
  { value: "2", label: "Season 2" },
  { value: "1", label: "Season 1" },
];

export const OVERVIEW_OPTIONS = {
  queueType: ALL_QUEUE_TYPE_OPTIONS,
  role: ALL_ROLE_OPTIONS,
  season: SEASON_OPTIONS,
};

export const OVERVIEW_DEFAULT = {
  queueType: ALL_QUEUE_TYPE_OPTIONS[0].value,
  role: ALL_ROLE_OPTIONS[0].value,
  season: SEASON_OPTIONS[0].value,
};

export const MATCH_HISTORY_OPTIONS = {
  queueType: ALL_QUEUE_TYPE_OPTIONS,
  role: ALL_ROLE_OPTIONS,
  season: SEASON_OPTIONS,
  exemptions: ["champion"],
};

export const MATCH_HISTORY_DEFAULT = {
  queueType: ALL_QUEUE_TYPE_OPTIONS[0].value,
  role: ALL_ROLE_OPTIONS[0].value,
  season: SEASON_OPTIONS[0].value,
  champion: "all",
};

export const CHAMPION_STATS_OPTIONS = {
  queueType: QUEUE_TYPE_ID_OPTIONS,
  role: ALL_ROLE_OPTIONS,
  season: CHAMPION_STATS_SEASON_OPTIONS,
};

export const CHAMPION_STATS_DEFAULT = {
  queueType: QUEUE_TYPE_ID_OPTIONS[0].value,
  role: ALL_ROLE_OPTIONS[0].value,
  season: CHAMPION_STATS_SEASON_OPTIONS[0].value,
};

export const INDIV_CHAMPION_STATS_OPTIONS = {
  queueType: QUEUE_TYPE_OPTIONS,
  role: ALL_ROLE_OPTIONS,
  season: SEASON_OPTIONS,
};

export const INDIV_CHAMPION_STATS_DEFAULT = {
  queueType: QUEUE_TYPE_OPTIONS[0].value,
  role: ALL_ROLE_OPTIONS[0].value,
  season: SEASON_OPTIONS[0].value,
};
